import React, { useState } from 'react';
import { CSVLink } from 'react-csv';
import {
  reactDrivingTableToDataDownload,
  reactTableToDataDownload,
} from './reactTableToDataDownload';
import { ButtonComponent } from '../../../ReusableComponents/Button/ButtonComponent';

async function runDownloadDrivingTable(
  columns,
  csvLink,
  setDataToDownload,
  reactTable
) {
  const data: any = reactDrivingTableToDataDownload(reactTable, columns);
  setDataToDownload(data);
  if (data.length) {
    csvLink.link.click();
  }
}

async function runDownload(columns, csvLink, setDataToDownload, reactTable) {
  const data: any = reactTableToDataDownload(reactTable, columns);
  setDataToDownload(data);
  if (data.length) {
    csvLink.link.click();
  }
}

export function DownloadCSVDrivingTable({
  columns,
  reactTable,
}: {
  columns;
  reactTable: any;
}) {
  const [dataToDownload, setDataToDownload] = useState([]);
  let csvLink: any = React.createRef();

  return (
    <div className="orderlisttable__header__buttons u-screen-only">
      <CSVLink
        data={dataToDownload}
        filename="data.csv"
        className="hidden"
        ref={r => (csvLink = r)}
        target="_blank"
      >
        <ButtonComponent
          onClick={async () =>
            await runDownloadDrivingTable(
              columns,
              csvLink,
              setDataToDownload,
              reactTable
            )
          }
        >
          Download CSV
        </ButtonComponent>
      </CSVLink>
    </div>
  );
}

export function DownloadCSV({
  columns,
  reactTable,
}: {
  columns;
  reactTable: any;
}) {
  const [dataToDownload, setDataToDownload] = useState([]);
  let csvLink: any = React.createRef();

  return (
    <div className="orderlisttable__header__buttons u-screen-only">
      <CSVLink
        data={dataToDownload}
        filename="data.csv"
        className="hidden"
        ref={r => (csvLink = r)}
        target="_blank"
      >
        <ButtonComponent
          onClick={async () =>
            await runDownload(columns, csvLink, setDataToDownload, reactTable)
          }
        >
          Download CSV
        </ButtonComponent>
      </CSVLink>
    </div>
  );
}
